import { getFEWalletParams } from "./../../../platform.pay.config";

export default function translateWrap(str) {
    const { languageType } = getFEWalletParams() || {} 
    return function translateInner() {
        let res = str;

        const translateDATA = require("./global.translate.static.json");
        res = translateDATA[str] ? translateDATA[str][languageType] : str;

        if (arguments.length) {
            res = res.replace(/\<\#([0-9]+)\#\>/g, (match, index) => {
                return arguments[index];
            });
        }

        return res;
    }
}